export default class AdminLabCategories {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminLabCategoriesRoute}`, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminLabCategoriesRoute}/${id}`, {})
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminLabCategoriesRoute}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminLabCategoriesRoute}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminLabCategoriesRoute}/${id}`, payload, {})
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminLabCategoriesRoute}/${id}`, {})
  }
}
